/* Configurateur perso custom (BiOui) - Phase 1 v3 - vanilla JS */
(function () {
  function rr(ctx, x, y, w, h, r) {
    if (typeof r === 'number') r = { tl: r, tr: r, br: r, bl: r };
    ctx.beginPath();
    ctx.moveTo(x + r.tl, y);
    ctx.lineTo(x + w - r.tr, y); ctx.arcTo(x + w, y, x + w, y + r.tr, r.tr);
    ctx.lineTo(x + w, y + h - r.br); ctx.arcTo(x + w, y + h, x + w - r.br, y + h, r.br);
    ctx.lineTo(x + r.bl, y + h); ctx.arcTo(x, y + h, x, y + h - r.bl, r.bl);
    ctx.lineTo(x, y + r.tl); ctx.arcTo(x, y, x + r.tl, y, r.tl);
    ctx.closePath();
  }

  // --- Contrôle du fichier d'impression (commande #52503 : PDF sans logo, aperçu correct) ---
  // Part des pixels d'une zone RGBA qui se distinguent nettement du fond : « y a-t-il un logo ici ? »
  function partHorsFond(px, fond) {
    var n = 0, tot = 0;
    for (var i = 0; i < px.length; i += 8) { // un pixel sur deux suffit
      tot++;
      if (Math.max(Math.abs(px[i] - fond[0]), Math.abs(px[i + 1] - fond[1]), Math.abs(px[i + 2] - fond[2])) > 48) n++;
    }
    return tot ? n / tot : 0;
  }
  // Le cadre du fichier d'impression montre-t-il le logo comme l'aperçu validé par le client ?
  // Logo absent = cadre uni (part nulle). Aperçu lui-même sans logo visible (glissé hors du cadre) : rien à exiger.
  function logoPresent(partApercu, partImpression) { return partApercu < 0.01 || partImpression >= partApercu * 0.25; }
  window.PCFG_controle = { partHorsFond: partHorsFond, logoPresent: logoPresent };

  function init() {
    var root = document.querySelector('[data-pcfg]'); if (!root) return;
    var canvas = document.getElementById('pcfg-canvas'), ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    var state = { logo: null, text: '00', font: 'PerArial', color: 'rgb(20,120,199)', corners: 'right', lx: 0.5, ly: 0.5, scale: 1, rotation: 0 };

    // format par défaut = auto (45×98, 2 stickers) ; le template peut surcharger via
    // data-pcfg-w / data-pcfg-h / data-pcfg-count (ex. moto : 30×65, 1 sticker)
    var REAL_W = parseFloat(root.getAttribute('data-pcfg-w')) || 45;
    var REAL_H = parseFloat(root.getAttribute('data-pcfg-h')) || 98;
    var MAX_H = (REAL_W === 45 && REAL_H === 98) ? 110 : REAL_H; // auto : hauteur max des 2 tailles
    var COUNT = parseInt(root.getAttribute('data-pcfg-count'), 10) || 2;
    var M = 18, GAP = 24;
    var sw, sh, startX, startY, stickers;
    function layout() {
      var availW = (W - 2 * M - GAP * (COUNT - 1)) / COUNT, availH = H - 2 * M;
      var sc = Math.min(availW / REAL_W, availH / MAX_H); // échelle constante -> largeur figée
      sw = REAL_W * sc; sh = REAL_H * sc;
      startX = (W - (COUNT * sw + GAP * (COUNT - 1))) / 2; startY = (H - sh) / 2;
      stickers = [];
      for (var si = 0; si < COUNT; si++) stickers.push({ x: startX + si * (sw + GAP), y: startY });
    }
    layout();

    // --- Phase 2 : polices vectorisables (opentype) parsées depuis le base64 (Shopify ne convertit pas le JS) ---
    var otFonts = {};
    function b64ToAB(b64) { var bin = atob(b64), n = bin.length, u = new Uint8Array(n); for (var i = 0; i < n; i++) u[i] = bin.charCodeAt(i); return u.buffer; }
    if (window.opentype && window.PCFG_FONT_DATA) {
      Object.keys(window.PCFG_FONT_DATA).forEach(function (k) {
        try { otFonts[k] = window.opentype.parse(b64ToAB(window.PCFG_FONT_DATA[k])); } catch (e) { }
      });
    }

    function frameOf(s) { var pad = sw * 0.075; return { x: s.x + pad, y: s.y + sh * 0.05, w: sw - 2 * pad, h: sh * 0.49 }; }
    function fitScale() { var fr = frameOf(stickers[0]); return Math.min(fr.w * 0.92 / state.logo.width, fr.h * 0.92 / state.logo.height); }
    function corners() {
      var R = sw * 0.1;
      if (state.corners === 'left') return { tl: R, tr: 0, br: 0, bl: R };
      if (state.corners === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 };
      return { tl: 0, tr: R, br: R, bl: 0 };
    }

    function drawSticker(s) {
      ctx.fillStyle = state.color;
      rr(ctx, s.x, s.y, sw, sh, corners()); ctx.fill();
      var fr = frameOf(s);
      if (state.logo) {
        ctx.save(); rr(ctx, fr.x, fr.y, fr.w, fr.h, 6); ctx.clip();
        var sc = fitScale() * state.scale;
        var lw = state.logo.width * sc, lh = state.logo.height * sc;
        var cx = fr.x + state.lx * fr.w, cy = fr.y + state.ly * fr.h;
        ctx.translate(cx, cy); ctx.rotate(state.rotation * Math.PI / 180);
        ctx.drawImage(state.logo, -lw / 2, -lh / 2, lw, lh);
        ctx.restore();
      } else {
        ctx.fillStyle = 'rgba(255,255,255,.45)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = (sw * 0.16) + 'px Arial';
        ctx.fillText('LOGO', fr.x + fr.w / 2, fr.y + fr.h / 2);
        ctx.strokeStyle = '#fff'; ctx.lineWidth = 3; ctx.setLineDash([11, 8]);
        rr(ctx, fr.x, fr.y, fr.w, fr.h, 6); ctx.stroke(); ctx.setLineDash([]);
      }
      if (state.text.trim() && otFonts[state.font]) {
        // même tracé que le fichier d'impression (printGeometry), à l'échelle de l'aperçu : le client voit le numéro
        // tel qu'il sera imprimé. measureText n'est pas fiable pour centrer : Safari décalait le numéro (iPhone, 31/10/2026).
        var font = otFonts[state.font], fsp = sh * 0.42, maxWp = sw * 0.86;
        var p0 = font.getPath(state.text, 0, 0, fsp), bb = p0.getBoundingBox();
        if ((bb.x2 - bb.x1) > maxWp) { fsp = fsp * maxWp / (bb.x2 - bb.x1); p0 = font.getPath(state.text, 0, 0, fsp); bb = p0.getBoundingBox(); }
        var pt = font.getPath(state.text, s.x + sw / 2 - (bb.x1 + bb.x2) / 2, s.y + sh * 0.77 + fsp * 0.34, fsp);
        pt.fill = '#fff'; pt.draw(ctx);
      } else if (state.text.trim()) {
        ctx.fillStyle = '#fff'; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
        var fs = sh * 0.42; ctx.font = fs + 'px ' + state.font;
        var maxW = sw * 0.86;
        while (ctx.measureText(state.text).width > maxW && fs > 20) { fs -= 4; ctx.font = fs + 'px ' + state.font; }
        var m = ctx.measureText(state.text), cx2 = s.x + sw / 2, x2;
        if (m.actualBoundingBoxLeft != null && m.actualBoundingBoxRight != null) { x2 = cx2 - (m.actualBoundingBoxRight - m.actualBoundingBoxLeft) / 2; }
        else { x2 = cx2 - m.width / 2; }
        ctx.fillText(state.text, x2, s.y + sh * 0.77);
      }
    }
    function draw() { ctx.clearRect(0, 0, W, H); stickers.forEach(drawSticker); savePlacement(); }

    function q(s) { return root.querySelector(s); }
    function setA(sel, el) { root.querySelectorAll(sel).forEach(function (x) { x.classList.remove('is-active'); }); el.classList.add('is-active'); }
    function savePlacement() { var h = q('[data-pcfg-placement]'); if (h) h.value = 'x=' + state.lx.toFixed(3) + ' y=' + state.ly.toFixed(3) + ' scale=' + state.scale.toFixed(2) + ' rot=' + state.rotation; }
    function updateFontPreviews() { root.querySelectorAll('[data-pcfg-fonts] button').forEach(function (b) { b.textContent = state.text.trim() ? state.text.toUpperCase() : b.getAttribute('data-default'); }); }

    // Le logo n'est prêt qu'une fois l'image décodée ET sa copie data URI (pour le SVG) lue : state.logoPret.
    // Un nouveau choix remet tout à zéro, pour ne jamais mélanger l'ancien logo et le nouveau.
    var fichierLogo = q('[data-pcfg-logo]');
    fichierLogo.addEventListener('change', function (e) {
      var f = e.target.files[0], wrap = q('[data-pcfg-tools]');
      state.logo = null; state.logoDataURL = null; state.logoPret = null;
      if (!f) { if (wrap) wrap.style.display = 'none'; draw(); return; }
      var img = new Image(), frd = new FileReader();
      var pret = state.logoPret = new Promise(function (ok, ko) {
        var n = 0;
        function fini() { if (++n === 2) ok(); }
        img.onload = function () {
          if (state.logoPret !== pret) return; // un autre logo a été choisi entre-temps
          state.logo = img; state.lx = 0.5; state.ly = 0.5; state.scale = 1; state.rotation = 0;
          var sl = q('[data-pcfg-logosize]'); if (sl) sl.value = 1;
          var rt = q('[data-pcfg-rotate]'); if (rt) rt.value = 0;
          if (wrap) wrap.style.display = 'block';
          draw(); fini();
        };
        img.onerror = function () {
          if (state.logoPret !== pret) return;
          ko(new Error('logo illisible'));
          alert(MSG_LOGO_ILLISIBLE);
        };
        frd.onload = function () { if (state.logoPret === pret) state.logoDataURL = frd.result; fini(); };
        frd.onerror = function () { ko(new Error('logo illisible')); };
      });
      pret.catch(function () { }); // l'échec est traité à l'ajout au panier
      img.src = URL.createObjectURL(f);
      frd.readAsDataURL(f);
    });
    var ti = q('[data-pcfg-text]'); if (ti) ti.addEventListener('input', function (e) { state.text = e.target.value; updateFontPreviews(); draw(); });
    root.querySelectorAll('[data-pcfg-fonts] button').forEach(function (b) { b.addEventListener('click', function () { state.font = b.getAttribute('data-font'); q('[data-pcfg-font-input]').value = b.getAttribute('data-label'); setA('[data-pcfg-fonts] button', b); draw(); }); });
    root.querySelectorAll('[data-pcfg-colors] button').forEach(function (b) { b.addEventListener('click', function () { state.color = b.getAttribute('data-color'); q('[data-pcfg-color-input]').value = b.getAttribute('data-color'); setA('[data-pcfg-colors] button', b); draw(); }); });
    root.querySelectorAll('[data-pcfg-corners] button').forEach(function (b) { b.addEventListener('click', function () { state.corners = b.getAttribute('data-corners'); q('[data-pcfg-corners-input]').value = b.getAttribute('data-label'); setA('[data-pcfg-corners] button', b); draw(); }); });
    var slider = q('[data-pcfg-logosize]'); if (slider) slider.addEventListener('input', function (e) { state.scale = parseFloat(e.target.value); draw(); });
    var rotate = q('[data-pcfg-rotate]'); if (rotate) rotate.addEventListener('input', function (e) { state.rotation = parseFloat(e.target.value); draw(); });
    var sizeSel = q('select[name="properties[Taille]"]'); if (sizeSel) sizeSel.addEventListener('change', function (e) { var o = e.target.options[e.target.selectedIndex]; REAL_W = parseFloat(o.getAttribute('data-w')) || 45; REAL_H = parseFloat(o.getAttribute('data-h')) || 98; layout(); draw(); });
    var qtyInput = q('[data-pcfg-qty]');
    function setQty(v) { v = Math.max(1, parseInt(v, 10) || 1); if (qtyInput) qtyInput.value = v; }
    var qm = q('[data-pcfg-qty-minus]'), qp = q('[data-pcfg-qty-plus]');
    if (qm) qm.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qp) qp.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    // drag du logo (permissif : si un logo est chargé, on peut le saisir n'importe où)
    var dragging = false, last = null;
    function pos(e) { var r = canvas.getBoundingClientRect(); var p = e.touches ? e.touches[0] : e; return { x: (p.clientX - r.left) * (canvas.width / r.width), y: (p.clientY - r.top) * (canvas.height / r.height) }; }
    function down(e) { if (!state.logo) return; dragging = true; last = pos(e); canvas.style.cursor = 'grabbing'; e.preventDefault(); }
    function move(e) { if (!dragging) return; var pt = pos(e), fr = frameOf(stickers[0]); state.lx = Math.max(-0.15, Math.min(1.15, state.lx + (pt.x - last.x) / fr.w)); state.ly = Math.max(-0.15, Math.min(1.15, state.ly + (pt.y - last.y) / fr.h)); last = pt; draw(); e.preventDefault(); }
    function up() { dragging = false; canvas.style.cursor = 'grab'; }
    canvas.style.cursor = 'grab';
    canvas.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    canvas.addEventListener('touchstart', down, { passive: false }); canvas.addEventListener('touchmove', move, { passive: false }); canvas.addEventListener('touchend', up);

    // --- Phase 2 : génération du fichier d'impression SVG (mm, calques CutContour) ---
    function rrPathMM(x, y, w, h, r) {
      if (typeof r === 'number') r = { tl: r, tr: r, br: r, bl: r };
      function n(v) { return Math.round(v * 1000) / 1000; }
      return 'M' + n(x + r.tl) + ',' + n(y) +
        ' H' + n(x + w - r.tr) + (r.tr ? ' A' + n(r.tr) + ',' + n(r.tr) + ' 0 0 1 ' + n(x + w) + ',' + n(y + r.tr) : ' L' + n(x + w) + ',' + n(y)) +
        ' V' + n(y + h - r.br) + (r.br ? ' A' + n(r.br) + ',' + n(r.br) + ' 0 0 1 ' + n(x + w - r.br) + ',' + n(y + h) : ' L' + n(x + w) + ',' + n(y + h)) +
        ' H' + n(x + r.bl) + (r.bl ? ' A' + n(r.bl) + ',' + n(r.bl) + ' 0 0 1 ' + n(x) + ',' + n(y + h - r.bl) : ' L' + n(x) + ',' + n(y + h)) +
        ' V' + n(y + r.tl) + (r.tl ? ' A' + n(r.tl) + ',' + n(r.tl) + ' 0 0 1 ' + n(x + r.tl) + ',' + n(y) : ' L' + n(x) + ',' + n(y)) + ' Z';
    }
    function cornersMM(stW) {
      var R = stW * 0.1;
      if (state.corners === 'left') return { tl: R, tr: 0, br: 0, bl: R };
      if (state.corners === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 };
      return { tl: 0, tr: R, br: R, bl: 0 };
    }
    // Géométrie du fichier d'impression, en mm : une seule source pour le SVG et pour le rendu du PDF,
    // afin que le PDF reste l'image exacte du SVG.
    function printGeometry() {
      var stW = REAL_W, stH = REAL_H, margin = 4.5, gap = 3;
      var g = { AB_W: 2 * margin + COUNT * stW + (COUNT - 1) * gap, AB_H: stH + 9, stW: stW, stH: stH, st: [] }; // auto : 102×107 (inchangé)
      for (var si = 0; si < COUNT; si++) {
        var s = { x: margin + si * (stW + gap), y: margin }, pad = stW * 0.075;
        s.fr = { x: s.x + pad, y: s.y + stH * 0.05, w: stW - 2 * pad, h: stH * 0.49 };
        if (state.logo) {
          var fit = Math.min(s.fr.w * 0.92 / state.logo.width, s.fr.h * 0.92 / state.logo.height), sc = fit * state.scale;
          s.logo = { w: state.logo.width * sc, h: state.logo.height * sc, cx: s.fr.x + state.lx * s.fr.w, cy: s.fr.y + state.ly * s.fr.h };
        }
        if (state.text.trim() && otFonts[state.font]) {
          var font = otFonts[state.font], maxW = stW * 0.86, fs = stH * 0.42;
          // centrage sur la BOÎTE ENGLOBANTE réelle (et non l'avance) -> centre visuel exact, toutes polices
          var p0 = font.getPath(state.text, 0, 0, fs), bb = p0.getBoundingBox();
          if ((bb.x2 - bb.x1) > maxW) { fs = fs * maxW / (bb.x2 - bb.x1); p0 = font.getPath(state.text, 0, 0, fs); bb = p0.getBoundingBox(); }
          var cx = s.x + stW / 2 - (bb.x1 + bb.x2) / 2;
          s.texte = font.getPath(state.text, cx, s.y + stH * 0.77 + fs * 0.34, fs);
        }
        g.st.push(s);
      }
      return g;
    }
    function buildPrintSVG() {
      var g = printGeometry(), AB_W = g.AB_W, AB_H = g.AB_H;
      var CUT = 'rgb(252,8,245)', CUTP = 'rgb(245,255,28)';
      // fond = aplat de couleur sur TOUTE la planche (dimension CutContour Plein)
      var design = '<rect x="0" y="0" width="' + AB_W + '" height="' + AB_H + '" fill="' + state.color + '"/>', cc = '', defs = '';
      g.st.forEach(function (s, i) {
        var fr = s.fr, L = s.logo;
        if (L && state.logoDataURL) {
          var cid = 'pcfgclip' + i;
          defs += '<clipPath id="' + cid + '"><path d="' + rrPathMM(fr.x, fr.y, fr.w, fr.h, g.stW * 0.013) + '"/></clipPath>';
          design += '<g clip-path="url(#' + cid + ')"><image xlink:href="' + state.logoDataURL + '" width="' + L.w + '" height="' + L.h + '" x="' + (-L.w / 2) + '" y="' + (-L.h / 2) + '" transform="translate(' + L.cx + ' ' + L.cy + ') rotate(' + state.rotation + ')"/></g>';
        }
        if (s.texte) design += '<path d="' + s.texte.toPathData(3) + '" fill="#ffffff"/>';
        cc += '<path d="' + rrPathMM(s.x, s.y, g.stW, g.stH, cornersMM(g.stW)) + '" fill="none" stroke="' + CUT + '" stroke-width="0.353"/>';
      });
      return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + AB_W + 'mm" height="' + AB_H + 'mm" viewBox="0 0 ' + AB_W + ' ' + AB_H + '">' +
        '<defs>' + defs + '</defs>' +
        '<g id="Design">' + design + '</g>' +
        '<g id="CutContour">' + cc + '</g>' +
        '<g id="CutContour Plein"><rect x="0" y="0" width="' + AB_W + '" height="' + AB_H + '" fill="none" stroke="' + CUTP + '" stroke-width="0.353"/></g>' +
        '</svg>';
    }
    window.PCFG_buildSVG = buildPrintSVG;
    window.PCFG_state = state;
    window.PCFG_setSize = function (h) { REAL_H = h; layout(); };

    // --- Phase 2b : PDF d'impression (design JPEG + contours découpe vecteur CMJN) ---
    function buildPrintPDF(jpegU8, jpegW, jpegH, AB_W, AB_H, coins) {
      var K = 72 / 25.4, pageW = AB_W * K, pageH = AB_H * K;
      var stW = REAL_W, stH = AB_H - 9, margin = 4.5, gap = 3;
      var st = [];
      for (var si = 0; si < COUNT; si++) st.push({ x: margin + si * (stW + gap), y: margin });
      function crn(c) { var R = stW * 0.1; if (c === 'left') return { tl: R, tr: 0, br: 0, bl: R }; if (c === 'none') return { tl: 0, tr: 0, br: 0, bl: 0 }; return { tl: 0, tr: R, br: R, bl: 0 }; }
      function nz(v) { return Math.round(v * 1000) / 1000; }
      function rr(x, y, w, h, r) {
        var k = 0.5523, o = [];
        o.push(nz(x + r.tl) + ' ' + nz(y) + ' m');
        o.push(nz(x + w - r.tr) + ' ' + nz(y) + ' l');
        if (r.tr) o.push(nz(x + w - r.tr + r.tr * k) + ' ' + nz(y) + ' ' + nz(x + w) + ' ' + nz(y + r.tr - r.tr * k) + ' ' + nz(x + w) + ' ' + nz(y + r.tr) + ' c'); else o.push(nz(x + w) + ' ' + nz(y) + ' l');
        o.push(nz(x + w) + ' ' + nz(y + h - r.br) + ' l');
        if (r.br) o.push(nz(x + w) + ' ' + nz(y + h - r.br + r.br * k) + ' ' + nz(x + w - r.br + r.br * k) + ' ' + nz(y + h) + ' ' + nz(x + w - r.br) + ' ' + nz(y + h) + ' c'); else o.push(nz(x + w) + ' ' + nz(y + h) + ' l');
        o.push(nz(x + r.bl) + ' ' + nz(y + h) + ' l');
        if (r.bl) o.push(nz(x + r.bl - r.bl * k) + ' ' + nz(y + h) + ' ' + nz(x) + ' ' + nz(y + h - r.bl + r.bl * k) + ' ' + nz(x) + ' ' + nz(y + h - r.bl) + ' c'); else o.push(nz(x) + ' ' + nz(y + h) + ' l');
        o.push(nz(x) + ' ' + nz(y + r.tl) + ' l');
        if (r.tl) o.push(nz(x) + ' ' + nz(y + r.tl - r.tl * k) + ' ' + nz(x + r.tl - r.tl * k) + ' ' + nz(y) + ' ' + nz(x + r.tl) + ' ' + nz(y) + ' c'); else o.push(nz(x) + ' ' + nz(y) + ' l');
        o.push('h'); return o.join(' ');
      }
      var C = crn(coins);
      // contenu balisé par calque (BDC/EMC) + tons directs CutContour (CS/SCN)
      var cont = '';
      cont += '/OC /oc1 BDC\nq ' + nz(pageW) + ' 0 0 ' + nz(pageH) + ' 0 0 cm /Im0 Do Q\nEMC\n';
      cont += '/OC /oc2 BDC\nq ' + nz(K) + ' 0 0 ' + nz(-K) + ' 0 ' + nz(pageH) + ' cm 0.353 w 1 J 1 j /CS1 CS 1 SCN\n';
      st.forEach(function (s) { cont += rr(s.x, s.y, stW, stH, C) + ' S\n'; });
      cont += 'Q\nEMC\n';
      cont += '/OC /oc3 BDC\nq ' + nz(K) + ' 0 0 ' + nz(-K) + ' 0 ' + nz(pageH) + ' cm 0.353 w /CS2 CS 1 SCN\n';
      cont += '0 0 m ' + AB_W + ' 0 l ' + AB_W + ' ' + AB_H + ' l 0 ' + AB_H + ' l h S\nQ\nEMC\n';
      var jstr = '';
      for (var i = 0; i < jpegU8.length; i += 8192) jstr += String.fromCharCode.apply(null, jpegU8.subarray(i, i + 8192));
      var objs = [];
      objs[1] = '<< /Type /Catalog /Pages 2 0 R /OCProperties << /OCGs [10 0 R 11 0 R 12 0 R] /D << /Order [10 0 R 11 0 R 12 0 R] /ON [10 0 R 11 0 R 12 0 R] /BaseState /ON >> >> >>';
      objs[2] = '<< /Type /Pages /Kids [3 0 R] /Count 1 >>';
      objs[3] = '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + nz(pageW) + ' ' + nz(pageH) + '] /Resources << /XObject << /Im0 5 0 R >> /ColorSpace << /CS1 6 0 R /CS2 8 0 R >> /Properties << /oc1 10 0 R /oc2 11 0 R /oc3 12 0 R >> >> /Contents 4 0 R >>';
      objs[4] = '<< /Length ' + cont.length + ' >>\nstream\n' + cont + 'endstream';
      objs[5] = '<< /Type /XObject /Subtype /Image /Width ' + jpegW + ' /Height ' + jpegH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jstr.length + ' >>\nstream\n' + jstr + '\nendstream';
      objs[6] = '[/Separation /CutContour /DeviceCMYK 7 0 R]';
      objs[7] = '<< /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [0.01 0.97 0.04 0] /N 1 >>';
      objs[8] = '[/Separation /CutContour#20Plein /DeviceCMYK 9 0 R]';
      objs[9] = '<< /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [0.04 0 0.89 0] /N 1 >>';
      objs[10] = '<< /Type /OCG /Name (Design) >>';
      objs[11] = '<< /Type /OCG /Name (CutContour) >>';
      objs[12] = '<< /Type /OCG /Name (CutContour Plein) >>';
      var pdf = '%PDF-1.5\n', off = [];
      for (var j = 1; j <= 12; j++) { off[j] = pdf.length; pdf += j + ' 0 obj\n' + objs[j] + '\nendobj\n'; }
      var xref = pdf.length;
      pdf += 'xref\n0 13\n0000000000 65535 f \n';
      for (var m = 1; m <= 12; m++) pdf += ('0000000000' + off[m]).slice(-10) + ' 00000 n \n';
      pdf += 'trailer\n<< /Size 13 /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF';
      var outb = new Uint8Array(pdf.length);
      for (var p = 0; p < pdf.length; p++) outb[p] = pdf.charCodeAt(p) & 0xff;
      return outb;
    }
    // --- Fichier d'impression : rendu direct du calque Design, contrôlé avant l'envoi ---
    // Avant le 28/10/2026, le PDF rastérisait le SVG chargé en <img>. Safari le dessinait parfois avant d'avoir
    // décodé le logo imbriqué en data URI : PDF avec fond et numéro mais SANS logo, alors que l'aperçu et le SVG
    // l'avaient (commande #52503, Safari 17.6). Le logo est désormais tracé directement depuis l'image déjà
    // décodée (celle de l'aperçu), puis vérifié ; en cas d'échec, nouvelle lecture du logo, sinon blocage.
    var MSG_LOGO_ILLISIBLE = 'Votre navigateur n\'a pas pu lire le fichier de votre logo. Merci de l\'importer au format PNG ou JPEG.';
    var MSG_LOGO_ABSENT = 'Votre logo n\'a pas pu être intégré au fichier d\'impression. Merci de cliquer à nouveau sur « Ajouter au panier ». Si ce message revient, rechargez la page et importez de nouveau votre logo.';
    var MSG_NUMERO = 'Le numéro n\'a pas pu être préparé pour l\'impression. Merci de recharger la page puis de recommencer.';
    function bloquant(message) { var e = new Error(message); e.bloquant = true; return e; }
    function couleurRGB(c) {
      var k = document.createElement('canvas'); k.width = k.height = 1;
      var x = k.getContext('2d'); x.fillStyle = c; x.fillRect(0, 0, 1, 1);
      var d = x.getImageData(0, 0, 1, 1).data; return [d[0], d[1], d[2]];
    }
    // Calque Design (fond, logos, numéros) à kx × ky px par mm, comme le SVG sans ses contours de découpe
    function drawPrintDesign(c, g, kx, ky) {
      c.fillStyle = '#ffffff'; c.fillRect(0, 0, c.canvas.width, c.canvas.height);
      c.save(); c.scale(kx, ky);
      c.fillStyle = state.color; c.fillRect(0, 0, g.AB_W, g.AB_H);
      c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
      g.st.forEach(function (s) {
        if (s.logo) {
          c.save(); rr(c, s.fr.x, s.fr.y, s.fr.w, s.fr.h, g.stW * 0.013); c.clip();
          c.translate(s.logo.cx, s.logo.cy); c.rotate(state.rotation * Math.PI / 180);
          c.drawImage(state.logo, -s.logo.w / 2, -s.logo.h / 2, s.logo.w, s.logo.h);
          c.restore();
        }
        if (s.texte) { s.texte.fill = '#ffffff'; s.texte.draw(c); }
      });
      c.restore();
    }
    // Vrai si un cadre du fichier d'impression a perdu le logo que l'aperçu (ce que voit le client) montre
    function logoManquant(cnv, g, kx, ky) {
      if (!state.logo) return false;
      var fond = couleurRGB(state.color), c = cnv.getContext('2d');
      for (var i = 0; i < g.st.length; i++) {
        var a = frameOf(stickers[i]), b = g.st[i].fr;
        var pa = partHorsFond(ctx.getImageData(Math.round(a.x), Math.round(a.y), Math.round(a.w), Math.round(a.h)).data, fond);
        var pi = partHorsFond(c.getImageData(Math.round(b.x * kx), Math.round(b.y * ky), Math.round(b.w * kx), Math.round(b.h * ky)).data, fond);
        if (!logoPresent(pa, pi)) return true;
      }
      return false;
    }
    // Nouvelle lecture du logo depuis sa copie data URI, décodée avant usage
    function relireLogo() {
      return new Promise(function (ok, ko) {
        if (!state.logoDataURL) return ko(new Error('logo'));
        var im = new Image();
        im.onload = function () {
          function fin() { if (state.logo) state.logo = im; ok(); }
          if (im.decode) im.decode().then(fin, fin); else fin();
        };
        im.onerror = ko;
        im.src = state.logoDataURL;
      });
    }
    // Rend le design (sans les contours) en JPEG via canvas -> cb(err, u8, w, h, AB_W, AB_H) ; err.bloquant = ne rien envoyer
    function buildDesignJPEG(cb) {
      var essai = 0;
      function rendre() {
        essai++;
        var res; // arguments de cb, appelé une seule fois et hors du try
        try {
          if (fichierLogo.files && fichierLogo.files[0] && !state.logo) res = [bloquant(MSG_LOGO_ILLISIBLE)];
          else if (state.text.trim() && !otFonts[state.font]) res = [bloquant(MSG_NUMERO)];
          else {
            draw(); // l'aperçu servant de référence reflète exactement l'état envoyé
            var g = printGeometry(), dpi = 400;
            var pxW = Math.round(g.AB_W / 25.4 * dpi), pxH = Math.round(g.AB_H / 25.4 * dpi), kx = pxW / g.AB_W, ky = pxH / g.AB_H;
            var cnv = document.createElement('canvas'); cnv.width = pxW; cnv.height = pxH;
            drawPrintDesign(cnv.getContext('2d'), g, kx, ky);
            if (logoManquant(cnv, g, kx, ky)) {
              if (essai < 3) { relireLogo().then(rendre, rendre); return; }
              res = [bloquant(MSG_LOGO_ABSENT)];
            } else {
              var b64 = cnv.toDataURL('image/jpeg', 0.92).split(',')[1];
              var bin = atob(b64), u8 = new Uint8Array(bin.length);
              for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
              res = [null, u8, pxW, pxH, g.AB_W, g.AB_H];
            }
          }
        } catch (e) { res = [e]; }
        cb.apply(null, res);
      }
      (state.logoPret || Promise.resolve()).then(rendre, function () { cb(bloquant(MSG_LOGO_ILLISIBLE)); });
    }

    // Ajout au panier (fetch direct -> gère l'upload du logo, contourne le JS du thème)
    var form = document.getElementById('pcfg-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('.pcfg__add'); var lbl = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
      function post(fd) {
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Erreur'); }); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function (err) { if (btn) { btn.disabled = false; btn.textContent = lbl; } alert('Erreur lors de l\'ajout au panier : ' + err.message); });
      }
      function send(previewBlob) {
        // le fichier d'impression PDF nécessite le rendu du design (asynchrone)
        buildDesignJPEG(function (err, u8, pxW, pxH, ABW, ABH) {
          if (err && err.bloquant) { // fichier d'impression incomplet : rien ne part au panier
            if (btn) { btn.disabled = false; btn.textContent = lbl; }
            alert(err.message);
            return;
          }
          var fd = new FormData(form);
          if (previewBlob) fd.append('properties[Aperçu]', previewBlob, 'apercu-perso.png');
          var svg = null; try { svg = buildPrintSVG(); } catch (e) { }
          var pdfOk = false;
          if (!err && u8) {
            try {
              var pu8 = buildPrintPDF(u8, pxW, pxH, ABW, ABH, state.corners);
              fd.append('properties[Fichier impression]', new Blob([pu8], { type: 'application/pdf' }), 'impression-perso.pdf');
              pdfOk = true;
              if (svg) fd.append('properties[_Fichier impression SVG]', new Blob([svg], { type: 'image/svg+xml' }), 'impression-perso.svg');
            } catch (e) { }
          }
          if (!pdfOk && svg) { // repli : SVG en principal si le PDF a échoué
            fd.append('properties[Fichier impression]', new Blob([svg], { type: 'image/svg+xml' }), 'impression-perso.svg');
          }
          post(fd);
        });
      }
      try { canvas.toBlob(function (blob) { send(blob); }, 'image/png'); } catch (e2) { send(null); }
    });

    // cale l'aperçu collant juste sous le header sticky/fixe du site
    (function () {
      var stage = root.querySelector('.pcfg__stage'); if (!stage) return;
      var hh = 0;
      document.querySelectorAll('header, #shopify-section-header, [id*="section-header"], [class*="site-header"], [class*="header__wrapper"], [class*="sticky"]').forEach(function (el) {
        var cs = getComputedStyle(el), rect = el.getBoundingClientRect();
        if ((cs.position === 'fixed' || cs.position === 'sticky') && rect.top < 70 && rect.height > 30 && rect.height < 280) hh = Math.max(hh, el.offsetHeight);
      });
      if (hh > 0) stage.style.top = (hh + 14) + 'px';
    })();

    updateFontPreviews();
    if (document.fonts && document.fonts.load) {
      Promise.all(['PerArial', 'PerCarstyle', 'PerT96'].map(function (f) { return document.fonts.load('40px ' + f); })).then(draw).catch(function () { });
    }
    draw();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
